import { EnumValueObject } from "./EnumValueObject";
import { InvalidLinkTypeError } from "./errors/InvalidLinkTypeMethod";

export enum LinkTypes {
  MAGIC_LINK = "magicLink",
  USER_LINK = "userLink",
}

export class LinkType extends EnumValueObject<LinkTypes> {
  constructor(value: string) {
    super(value, Object.values(LinkTypes));
  }

  protected throwErrorForInvalidValue(value: LinkTypes): void {
    throw new InvalidLinkTypeError(value.toString());
  }
}
